module.exports = __webpack_public_path__ + "static/media/24UHCHR23.0c5eda6e.jpg";